import { defineStore } from "pinia";
import { Printer } from '../other/DataStructs'
import { useTicketsStore } from "./tickets";
import { ref } from "vue";
import axios from "axios";
import { useAuthStore } from "./authStore";

export const usePrinterStore = defineStore("printerStore", {
    state: () => {
        return {
            //printers
            printers: ref([] as Printer[]),
            editPrinter: new Printer("", "", 0, [0, 0, 0], 0, "0"),
            editTicketQueue: [] as any[]
        };

    },
    actions: {
        async fetchPrinters() {
            const responseObject: any = await axios.get(`${process.env.VUE_APP_API_URL}/database/printers/`, {
                headers: {
                    Authorization: `Bearer ${useAuthStore().sessiontoken}`
                }
            });
            const printersRaw = responseObject.data.items;

            this.printers.length = 0;

            for (const printerR of printersRaw) {
                const printer = new Printer(
                    printerR.name,
                    printerR.image_string,
                    printerR.color_in_use_id,
                    printerR.print_dimensions ? printerR.print_dimensions : [0, 0, 0],
                    printerR.print_resolution,
                    printerR.id
                );

                this.printers.push(printer);
            }
        },
        postPrinter(printer: Printer) {
            const formData = new FormData();
            formData.append('name', printer.name);
            formData.append('image_string', printer.fileImageAddress);
            formData.append('color_in_use_id', printer.colorInUse.toString());
            formData.append('print_resolution', printer.colorInUse.toString());

            axios.post(`${process.env.VUE_APP_API_URL}/database/tickets/`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${useAuthStore().sessiontoken}`
                    }
                }
            )
                .then((response) => {
                    console.log(response);
                    //updating ui
                    const id = response.data.ticket_id;
                    printer.id = id;
                    this.printers.push(printer)
                }, (error) => {
                    console.log(error);
                });
        },


        /**
         * Loads in the tickets, which are in the ticketQueue from its id.
         * @param printer the specific printer from which the ticketqueue should be filled.
         */
        setEditTicketQueue(printer: Printer) {
            const ticketStore = useTicketsStore();
            this.editTicketQueue.length = 0;

            for (let i = 0; i < printer.ticketQueue.length; i++) {
                const id = printer.ticketQueue[i];
                this.editTicketQueue.push(ticketStore.getTicket(id));
            }
        }
    },

});